export default __webpack_public_path__ + "static/media/settings.2559551e.svg";